import { useQuery } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

export const availableLanguagesQueryKey = () => ['configurations', 'languages'] as const

export interface AvailableLanguage {
  code: string
  flag: string
}

export function useAvailableLanguagesQuery() {
  return useQuery({
    queryKey: availableLanguagesQueryKey(),
    queryFn: async () => {
      const result = (await fetchApi<{ languages: AvailableLanguage[] }>({
        endpoint: '/api/configurations/languages',
      })) as { languages: AvailableLanguage[] } | null
      return result?.languages ?? []
    },
    staleTime: 5 * 60 * 1000,
  })
}
